import {
  FormPayload,
  FormPayloadItem,
  PayLoadValue,
} from '@cashier/cashier-model';

export const PaymentAttributesMapper = {
  fromPayload: (payload: FormPayload): { [key: string]: PayLoadValue } => {
    return Object.fromEntries(
      Object.entries(payload)
        .filter(([_, item]: [string, FormPayloadItem]) => !item.isUiOnly)
        .map(([key, item]: [string, FormPayloadItem]) => [key, item.value]),
    );
  },
};
